import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryActive, brandPrimaryHover, header } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
	},
	section: {
		marginTop: 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: 8,
	},
	detailsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		padding: 16,
	},
	detailRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	label: {
		color: header,
		fontSize: 13,
		fontWeight: 600,
	},
	value: {
		fontSize: 13,
	},
	quickActions: {
		display: 'flex',
		gap: 8,
		justifyContent: 'center',
	},
	quickActionButton: {
		':active': {
			background: brandPrimaryActive,
		},
		':hover': {
			background: brandPrimaryHover,
		},
		alignItems: 'center',
		background: brandPrimary,
		borderRadius: '50%',
		cursor: 'pointer',
		display: 'flex',
		height: 40,
		justifyContent: 'center',
		width: 40,
	},
});
